import { render } from "./batchOrderConfirmModal.vue?vue&type=template&id=a4e1979a&scoped=true"
import script from "./batchOrderConfirmModal.vue?vue&type=script&lang=js"
export * from "./batchOrderConfirmModal.vue?vue&type=script&lang=js"

import "./batchOrderConfirmModal.vue?vue&type=style&index=0&id=a4e1979a&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4e1979a"]])

export default __exports__